<template>
<div class="w-full">
 <app-header></app-header>
  <div class="login-main-wrapper py-60">
    <div class="container">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 text-center">
          <div class="min-h-70vh relative-hidden">
            <div class="login-content" v-if="loading">
              <loading :message="'Please wait while we are verifying your data.'" />
            </div>
            <div class="login-content" v-else>
              <p class="mb-5" v-html="result.message">Please type in your new password.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
 
</template>

<script>
  import Env from '@/env';
  import Helpers from '@/helpers/index';
  import NormalApis from '@/controllers/NormalApis';

export default {
  name: 'VerifyEmail',
  data() {
    return {
      loading: false,
      result: {
        status: false,
        message: '',
      } 
    }
  },
  mounted() {
    if(this.$route.query.token){
      this.loading = true;
      this.verifyToken();
    } else {
      this.$router.push({
        name: 'Login'
      })
    }
  },
  methods: {
    verifyToken() {
      const url = `${Env.baseUrl}/verify-email`;
      NormalApis.postApi(url, {}, { token: this.$route.query.token})
      .then(res => {
        this.loading = false;
        this.result.message = res.data.message;
        setTimeout(()=>{
          this.$router.push({ name: 'Login'})
        }, 3000)
      }).catch(err => {
        this.loading = false;

        this.result.message = err.response ? err.response.data ? err.response.data.errors[0] : "Fail." : "Please try again later.",
 
        setTimeout(()=>{
          this.$router.push({ name: 'Login'})
        }, 3000)
      })
    },

  },
}
</script>
